// extracted by mini-css-extract-plugin
module.exports = {"procedureName":"styles_procedureName__380gB","colMin":"styles_colMin__1B8ll","colCheckbox":"styles_colCheckbox__6oi8U"};